import React,{useState,useEffect} from 'react';
import { Link } from 'react-router-dom';
import './lottery.css'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import im1 from "./Im/1.png"
// import ProgressBar from "@ramonak/react-progress-bar";
import Footer from '../../Home/Home_modules/Footerr/footer'
import firebaseConfig from '../../fire';
import firebase from 'firebase/compat/app';
import Progressbar from '../../Components/progressbar'

function LotteryMain() {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      partialVisibilityGutter: 140
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 140
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    }
  };

  const [lotteryData, setLotteryData] = useState([]);
  useEffect(() => {
    const blogRef = firebase.firestore().collection('lottery');

    blogRef.get().then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })); 
     // console.log(data)
      setLotteryData(data);
    });
}, []); 

console.log(lotteryData);

  return (
      <>
      <div className='main'>
          <div className="lottery-main">
            <div className="lottery-video">
              <video autoPlay loop muted>
                <source src="https://www.youtube.com/embed/dQw4w9WgXcQ" type="video/mp4" />
              </video>
            </div>
            <div className="lottery-section-2">
              <h2>LOTTERY GAME</h2>
              <div className="lottery-section-2-grid">
                <div>
                  <h3>Rules</h3>
                  <p>1. Lorem Ipsum is simply dummy text of the printing and typesetting industry. <br/><br/>
                    2. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. <br/><br />
                    3. when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                    </p>
                </div>
                <div>
                  <h3>Potential Rewards</h3>
                  <div className="lottery-rewards-card">
                    <img />
                    <p>the selected nft</p>
                  </div>
                </div>
                <div>
                <div className="lottery-rewards-card">
                    <img />
                    <p>the pool money</p>
                    </div>
                </div>
              </div>
            </div>
            <div className='lottery-section-3'>
              <h2>PICK A LOTTERY TO PARTICIPATE IN</h2>
              <Carousel 
                 responsive={responsive}
                 partialVisible={true}
                 showDots={true}
                 autoPlay={false}
                 autoPlaySpeed={5000}
                 infinite={true}
                 containerClass='movies-slider'
                 removeArrowOnDeviceType={["desktop","tablet", "mobile"]}
                 >
                   {lotteryData.map((data) => {

                     return(
                      <div key={data.id} className="lottery-featured-slider">
                      <div className="lottery-featured-slider-main">
                      <div className="lottery-featured-content">
                          <h1>{data.lottery_name}</h1>
                        <Link to={`/lottery/${data.id}`}><button className="lottery-slide-btn">ENTER CONTEST</button></Link> 
                         <div className='lottery-content-grid'>
                           <div>
                             <h3>No. of players</h3>
                             <h2>{data.total_players}</h2>
                           </div>
                           <div>
                             <h3>Ticket price</h3>
                             <h2>${data.ticket_price}</h2>
                           </div>
                           <div>
                             <h3>Prize pool</h3>
                             <h2>${data.prize_pool}</h2>
                           </div>
                         </div>
                         <div className="lottery-progress-bar">
                           <h4>Number of tickets to activate lottery</h4>
                         <div>{data.total_tickets}
                           <Progressbar bgcolor="black" progress={data.total_tickets} borderColor="black"  height={49} />
                         100
                         </div>
                         </div>
                      </div>
                      <div className="featured-image">
                          <img src={data.lottery_image}/>
                      </div>
                      </div>
                  </div>
                     )
                   }
                   )
                   }
            </Carousel>
              </div>
              <div className="lottery-section-4">
                <h2>WINNER HISTORY</h2>
                <div>
                  <div>
                    <div className="lottery-winner-card">
                      <div>
                        <img />
                      </div>
                      <div>
                        <h4>Wallet Address</h4>
                        <p>September 28th, 2021</p>
                      </div>
                      <div>
                        <h4>Prize</h4>
                        <p>Sivaji</p>
                      </div>
                      </div>
                      <div className="lottery-winner-card">
                      <div>
                        <img />
                      </div>
                      <div>
                        <h4>Wallet Address</h4>
                        <p>September 28th, 2021</p>
                      </div>
                      <div>
                        <h4>Prize</h4>
                        <p>Sivaji</p>
                      </div>
                      </div>
                  </div>
                  <div>
                  <div className="lottery-winner-card">
                      <div>
                        <img />
                      </div>
                      <div>
                        <h4>Wallet Address</h4>
                        <p>September 28th, 2021</p>
                      </div>
                      <div>
                        <h4>Prize</h4>
                        <p>Sivaji</p>
                      </div>
                      </div>
                      <div className="lottery-winner-card">
                      <div>
                        <img />
                      </div>
                      <div>
                        <h4>Wallet Address</h4>
                        <p>September 28th, 2021</p>
                      </div>
                      <div>
                        <h4>Prize</h4>
                        <p>Sivaji</p>
                      </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer/>
          </>
  )
}

export default LotteryMain;